import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const sharedData: Pick<LocDef, 'htmlAllowed' | 'shared' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
};

export type SPAchievementCardLocs = 'SPAchievementCardChange';

export const spAchievementCardLocs: LocDefs<SPAchievementCardLocs> = {
	SPAchievementCardChange: {
		defaultValue: 'Change',
		description: 'Button for changing the selecetd credential.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.Button.ChangeSelectedCredential',
		displayPath: 'Catalogs|Achievements|Details|Change Selected Credential Button',
		displayType: 'Button',
		feature: HubFeature.CredentialAchievements,
		...sharedData,
	},
};

export type SPAchievementCardLocKeys = LocMap<SPAchievementCardLocs>;

export const spAchievementCardLocKeys: SPAchievementCardLocKeys =
	MapLocKeys<SPAchievementCardLocs>(spAchievementCardLocs);
